import { getIncidentTypeLabel } from "@/lib/utils/matters/incident-classification";
import { DataTableColumnHeader } from "@/components/ui";
import { type RecentMatter } from "@/lib/types";
import type { ColumnDef } from "@tanstack/react-table";

export const getDashboardMostRecentMattersColumns = (): ColumnDef<
  RecentMatter,
  string
>[] =>
  [
    {
      accessorKey: "title",
      id: "Matter",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => row.original.title,
      enableHiding: false,
    },
    {
      accessorKey: "status.label",
      id: "Status",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => row.original.status.label,
    },
    {
      accessorKey: "incidentType.label",
      id: "Incident Type",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => getIncidentTypeLabel(row.original.incidentType),
    },
  ] as ColumnDef<RecentMatter, string>[];
